<ng-template #rt let-r="result" let-t="term">
  <ngb-highlight [result]="r.HSN_CODE + '  ' + r.DDC_CODE + '  - ' + r.TRADE_NAME" [term]="t"></ngb-highlight>
</ng-template>

<app-page-header [heading]="'Purchase Order'" [icon]="'fa-file-text-o'" style="height:100px;"></app-page-header>
<div *ngIf="user_rights.ADD == '1'" class="page-panel">
  <div class="clearfix"></div>
  <div class="clearfix"></div>
  <div class="row">
    <div class="form-group col-lg-4">
      <label>Supplier Name</label><span class="text-danger">&nbsp;*</span>
      <ngx-select-dropdown (change)="getVendor($event)" [(ngModel)]="vendor_data"
        [config]="utils.dropConfig({displayKey: 'VENDOR_NAME',placeholder: 'Select Supplier',searchOnKey: 'VENDOR_NAME'})"
        [multiple]="false" [options]="vendor_options" class="form-control  select-dropdown"
        name="sel_tpa_receiver"></ngx-select-dropdown>
    </div>

    <div class="form-group col-lg-4">
      <label for="date">Order Date</label><span class="text-danger">&nbsp;*</span>
      <input (ngModelChange)="purchase_order.order_date = $event" [max]="getToday()"
        [ngModel]="purchase_order.order_date | date:'yyyy-MM-dd' " class="form-control " id="date" name="date"
        type="date">
    </div>
    <div class="form-group col-lg-4">
      <label for="date">Ship To</label><span class="text-danger">&nbsp;*</span>
      <textarea [(ngModel)]="purchase_order.ship_to" class="form-control " name="ship_to"></textarea>
    </div>

  </div>
  <hr>
  <h5 class="list-header">Add Particular</h5>
  <div class="clearfix"></div>
  <div class="clearfix"></div>
  <div class="form-group">
    <table class="tbl table tbl-sm  table-bordered">
      <thead>
        <tr class="text-center">
          <th>#</th>
          <th width="25%">Particular<span class="text-danger">&nbsp;*</span></th>
          <th>UOM</th>
          <th width="8%">Quantity<span class="text-danger">&nbsp;*</span></th>
          <th>Unit Price</th>
          <th>Total Price</th>
          <th>Last purchase Price</th>
          <th>Last purchase date</th>
            <th width="10%">Last purchase supplier</th>
          <th>*</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let i of utils.buildArray(purchase_order_details.length)">
          <td class="text-center">{{ 1 + i }}</td>
          <td>
            <input (selectItem)="set_item_medicine($event,i)" [(ngModel)]="purchase_order.medicine_data[i]"
              [class.is-invalid]="searchFailed" [inputFormatter]="formatter" [ngModelOptions]="{standalone: true}"
              [ngbTypeahead]="medicine_search" [resultTemplate]="rt" class="form-control" id="typeahead-http{{i}}"
              placeholder="Search Particular Name...." style="height: 29px;" type="text" />
          </td>
          <td>
            <input [(ngModel)]="purchase_order.uom_name[i]" [readOnly]="true" class="form-control" name="uom_name{{i}}"
              tabindex="-1" type="text">
          </td>

          <td>
            <input (focusout)="totalprice()" [(ngModel)]="purchase_order.quantity[i]" class="form-control text-right"
              maxlength="8" name="quantity{{i}}" type="text" (input)="allowNumberOnly($event)">
          </td>
          <td>
            <input (focusout)="totalprice()" [(ngModel)]="purchase_order.medicine_price[i]"
              class="form-control text-right" maxlength="8" name="medicine_price{{i}}" type="text" (input)="allowNumberOnly($event)">
          </td>
          <td>
            <input [(ngModel)]="purchase_order.total[i]" [readOnly]="" class="form-control text-right" name="total{{i}}"
              tabindex="-1" type="text" (input)="allowNumberOnly($event)" maxlength="10">
          </td>
          <td>
            <input [(ngModel)]="purchase_order.unitprice[i]" [readOnly]="" class="form-control text-right" maxlength="10"
              name="amount{{i}}" tabindex="-1" type="text" (input)="allowNumberOnly($event)">
          </td>
          <td>
            <input [(ngModel)]="purchase_order.last_pur_date[i]" [readOnly]="true" class="form-control"
              name="date{{i}}" placeholder="dd/mm/yyyy" tabindex="-1" type="text">
          </td>
            <td>
                <span>{{purchase_order.last_pur_vendor[i]}}</span>
            </td>
          <td>
            <div class="d-flex justify-content-end">
              <button (click)="addrow(i)" *ngIf="i == purchase_order_details.length-1"
                class="btn btn-success btn-sm mr-2" title="Add New data" type="button"><i class="fa fa-plus"
                  style="color: white;"></i>
              </button>
              <button (click)="deleterow(i)" *ngIf="purchase_order_details.length > 1" class="btn btn-danger  btn-sm "
                title="Delete data" type="button"><i class="fa fa-trash" style="color: white;"></i></button>
            </div>

          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="8" style="text-align: right"><label>Grand Total ({{env.CURRENCY}})&nbsp;&nbsp;</label></td>
          <td style="text-align: right;width:10%"><label>{{ purchase_order.total_amount | number : '1.2-2' }}</label>
          </td>
        </tr>
      </tfoot>
    </table>
    <div class="clearfix"></div>
  </div>
  <hr>
  <div class="clearfix"></div>
  <div class="row container">
    <div class="col-lg-7 pull-right">
      <button (click)="savePurchaseOrder();" *ngIf="user_rights.ADD == '1'" class="btn btn-info btn-sm ng-star-inserted"
        type="button">&nbsp;Save&nbsp;
      </button>&nbsp;&nbsp;&nbsp;
    </div>
  </div>
  <div class="clearfix"></div>
</div>
<div *ngIf="orderd && item_list" id="printOrder" style="display: none">
  <div>
    <div class="header-space">&nbsp;</div>
    <div class="footer-space">&nbsp;</div>
    <div class="header col-sm-12">
      <div class="row col-sm-12">
        <div class="col-sm-6" style="margin-top:30px;">
          <ng-container *ngIf="institution.INSTITUTION_LOGO">
            <img alt="" class="pull-left" height="150" ngSrc="{{logo_path+institution.INSTITUTION_LOGO}}" width="150">
          </ng-container>
        </div>
        <div class="col-sm-6 text-right" style="margin-top:30px;">
          <ng-container *ngIf="institution">
            <h5 class="name"><b>{{ institution.INSTITUTION_NAME }}</b></h5>
            <div style="line-height: 0.5em;"><label>{{ institution.INSTITUTION_ADDRESS }}</label></div>
            <div style="line-height: 0.5em;"><label>{{ institution.INSTITUTION_CITY }}
                ,{{ institution.INSTITUTION_COUNTRY_NAME }}</label></div>
            <div style="line-height: 0.5em;"><label>Ph :{{ institution.INSTITUTION_PHONE_NO }}</label></div>
            <div style="line-height: 0.5em;"><label>Email :{{ institution.INSTITUTION_EMAIL }}</label></div>
            <div style="line-height: 0.5em;"><label>VAT
                IN&nbsp;&nbsp;:&nbsp;&nbsp;{{ institution.INSTITUTION_VAT_NO }}</label></div>
            <div style="line-height: 0.5em;"><label>State
                Code&nbsp;&nbsp;:&nbsp;&nbsp;{{ institution.TIN_NUMBER }}</label></div>
          </ng-container>
        </div>
      </div>
      <div *ngIf="institution" class="footer col-sm-12 text-center">
        <hr>
        {{ institution.INSTITUTION_NAME }}<br>{{ institution.INSTITUTION_ADDRESS }},{{ institution.INSTITUTION_CITY }}
        ,{{ institution.INSTITUTION_COUNTRY_NAME }}
      </div>
      <h5 class="text-center">PURCHASE ORDER</h5>
      <br>
      <div>&nbsp;</div>
      <main>
        <div *ngIf="orderd" class="row container">
          <table cellpadding="0" cellspacing="0" class="col-lg-12" style="margin-left:15px">
            <tr style="display: none">
              <thead>
                <th></th>
                <th></th>
                <th class="pull-right"></th>
                <th class="pull-right"></th>
              </thead>
            </tr>

            <tr>
              <td>Supplier&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;{{ orderd.VENDOR_NAME }}</td>
              <td class="text-right">Order No &nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;{{ orderd.PURCHASE_ORDER_NUMBER }}</td>
            </tr>
            <tr>
              <td>Address&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;{{ orderd.VENDOR_ADDRESS }}</td>
              <td class="text-right">Order Date&nbsp;&nbsp; :&nbsp;
                &nbsp;&nbsp;{{ orderd.PURCHASE_ORDER_DATE| date:'dd/MM/yyyy' }}
              </td>
            </tr>
          </table>
        </div>
        <div>&nbsp;</div>
        <table cellpadding="0" cellspacing="0" class="table table-bordered table-striped">
          <thead>
            <tr class="text-center">
              <th width="5%">Sl</th>
              <th>Item</th>
              <th width="10%">UOM</th>
              <th width="15%">Quantity</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of item_list;let i=index">
              <td class="text-center">{{ 1 + i }}</td>
              <td> {{ item.TRADE_NAME }}</td>
              <td class="text-center">{{ item.SHORT_FORM }}</td>
              <td class="text-center">{{ item.QUANTITY }}</td>
            </tr>
          </tbody>
        </table>
      </main>
      <div class="clearfix"></div>
    </div>
  </div>
</div>
